import { ArrowUpIcon } from '@heroicons/react/24/outline';
import './style.scss';
import { OptimizationSummaryItem } from '../../../../types/GLDashboardTypes';
import { useNavigate } from 'react-router-dom';

interface OptimizationSummaryProps {
  data?: OptimizationSummaryItem[];
}

const OptimizationSummary: React.FC<OptimizationSummaryProps> = ({ data }: OptimizationSummaryProps) => {
  const rows = Array.isArray(data) ? data : [];

  const navigate = useNavigate();
  const handleClick = (state: Record<string, string>) => {
    navigate('/recommendations', { state });
  };
  return (
    <div className='optimization-summary'>
      <div className='optimization-summary__title'>Optimization summary</div>
      <div className='optimization-summary__container'>
        <div className='optimization-summary__total'>Total change</div>
        <div className='optimization-summary__content'>
          {rows.length === 0 ? (
            <div className='optimization-summary__empty'>
              <p>No optimization opportunities match the current filters.</p>
            </div>
          ) : (
            rows.map((item, index) => (
              <div className='optimization-summary__content-item' key={index}>
                <div className='optimization-summary_item-title'>{item.text}</div>
                <div className='optimization-summary_item_indicator'>Increase</div>
                <div className='optimization-summary_item-value'>{item.value} Bopd</div>
                <div className='optimization-summary__change'>
                  <ArrowUpIcon className='h-4 w-4 text-green-500' />
                  <span>{item.wellcount} wells</span>
                </div>
                <div className='optimization-summary__recommendation' onClick={() => handleClick(item.navigateState)}>
                  View recommendations
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default OptimizationSummary;
